const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

const monthNamesShort = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];

const monthNumbers = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12'
];

export const dayNames = {
    sun: 'Sunday',
    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday'
};

export function getFormattedTime(theTime) {

    const matches = theTime.match(/(\d\d):(\d\d):(\d\d)/);

    let hour = matches[1],
        minute = matches[2],
        ampm = parseInt(hour) >= 12 ? 'pm' : 'am';
    
    hour = parseInt(hour) % 12;
    hour = (hour != 0) ? hour : 12;

    return hour+':'+minute+ampm;
}

export function getFormattedPickupTime(inputPickupTime) {
    
    let year = inputPickupTime.getFullYear(),
        month = monthNumbers[inputPickupTime.getMonth()],
        day = (inputPickupTime.getDate() <= 9) ? '0'+inputPickupTime.getDate() : inputPickupTime.getDate(),
        hour = (inputPickupTime.getHours() <= 9) ? '0'+inputPickupTime.getHours() : inputPickupTime.getHours(),
        minute = (inputPickupTime.getMinutes() <= 9) ? '0'+inputPickupTime.getMinutes() : inputPickupTime.getMinutes(),
        second = "00";

    return year+'-'+month+'-'+day+' '+hour+':'+minute+':'+second;
}